import api from "api/api"

export const GET_BANKS = "[BANKS] GET BANKS"
export const GET_BANK_ACCOUNT_TYPES = "[BANKS] GET BANK ACCOUNT TYPES"

export function getBanksAction() {
  const req = api.get(`/banks`)
  return (dispatch) => {
    dispatch({ type: GET_BANKS, payload: { loading: true } })
    req.then(({ data }) => {
      dispatch({ type: GET_BANKS, payload: { data: data.data } })
    }).catch((error) => {
      dispatch({ type: GET_BANKS, payload: { data: [] } })
      console.log(GET_BANKS, error)
    }).finally(() => {
      dispatch({ type: GET_BANKS, payload: { loading: false } })
    })
  }
}

export function getBankAccountTypesAction() {
  const req = api.get(`/bank-account-types`)
  return (dispatch) => {
    dispatch({ type: GET_BANK_ACCOUNT_TYPES, payload: { loading: true } })
    req.then(({ data }) => {
      dispatch({ type: GET_BANK_ACCOUNT_TYPES, payload: { data: data.data } })
    }).catch((error) => {
      dispatch({ type: GET_BANK_ACCOUNT_TYPES, payload: { data: [] } })
      console.log(GET_BANK_ACCOUNT_TYPES, error)
    }).finally(() => {
      dispatch({ type: GET_BANK_ACCOUNT_TYPES, payload: { loading: false } })
    })
  }
}
